export function truncate(str: string | null, n: number, useWordBoundary: boolean) {
  if (!str || str.length <= n) {
    return str;
  }
  const subString = str.substr(0, n - 1); // the original check
  return `${useWordBoundary ? subString.substr(0, subString.lastIndexOf(' ')) : subString}...`;
}

export function isWhitespaceOrEmptyString(str: string) {
  return str.trim() === '';
}

export function isWhitespaceString(str: string) {
  return str && str.length > 0 && str.trim() === '';
}
